module.exports = __webpack_public_path__ + "static/img/marina-richie.6ca97c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marina-richie.jpg
// module id = 889
// module chunks = 0